<span [hidden]="!isLoading" class="text-xs-center">
  <i class="fas fa-circle-notch fa-spin"></i> <span>{{message}}</span>
</span>
